// extracted by css-extract-rspack-plugin
export default {"emptyContainer":"empty-container_Wxpjl","emptyText":"empty-text_NZw9E"};